//
//
//
//
//
//

export default {
  name: 'App',
  mounted(){
	 this.jsapiTicket();
  },
  methods:{
	  jsapiTicket(){
				let this_ = this;
				let param = {
					wechat:this.utils.getQueryVariable("wechat"),
					url:location.href.split('#')[0]
				}
				this.$http.post("jsapiTicket.do",param).then(function(data){
					if(data.respCode == '0000'){
							wx.config({
								debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
								appId: data.appid, // 必填，公众号的唯一标识
								timestamp: data.timestamp, // 必填，生成签名的时间戳
								nonceStr: data.noncestr, // 必填，生成签名的随机串
								signature: data.signature,// 必填，签名
								jsApiList: [
									'updateAppMessageShareData',//分享到微信朋友或QQ
									'startRecord',
									'stopRecord',
									'uploadVoice',
									'playVoice',
									'chooseImage'
									] // 必填，需要使用的JS接口列表
							});
					}
				})
			}
  }
}



// WEBPACK FOOTER //
// ./src/App.vue